import React from 'react';

import PropTypes from 'prop-types';

const Header = ({ isRead, senderName, sentAgo, subject }) => (
  <div>
    <div className="flex items-center justify-between">
      <div className="flex items-center gap-2">
        <span className="text-sm font-semibold">{senderName}</span>
        {!isRead && <div className="w-2 h-2 rounded-full bg-blue-500" />}
      </div>

      <span className="text-xs text-muted-foreground">{sentAgo}</span>
    </div>

    <p className="text-xs">{subject}</p>
  </div>
);

Header.propTypes = {
  isRead: PropTypes.bool.isRequired,
  senderName: PropTypes.string.isRequired,
  sentAgo: PropTypes.string.isRequired,
  subject: PropTypes.string.isRequired,
};

export default Header;
